import { formatDate } from 'lib/helpers/utility';

export const DEFAULT_FILTERS = {
  created_at: {
    values: null,
    type: 'date-range',
    title: 'Created At',
    preview: (values) => `${formatDate(values.startDate)} - ${formatDate(values.endDate)}`
  },
  code: {
    type: 'search',
    values: null,
    title: 'Code',
    placeholder: 'Search by Code',
    preview: (values) => values
  },
  name: {
    type: 'search',
    values: null,
    title: 'Name',
    placeholder: 'Search by Name',
    preview: (values) => values
  }
};
